export function isShopifyEmail(email: string | undefined): boolean {
  return email?.toLowerCase().endsWith("@shopify.com") ?? false;
}
